module.exports = __webpack_public_path__ + "img/ev-logo-nobg.9e94f673.svg";